import { usePaginatedCollections } from 'lib-knowledge-management-common/hooks/usePaginatedCollections';
import { useMemo } from 'react';

/**
 * Collection id to name, for the collections the given drafts are filed under.
 *
 * `AiDraft` carries only a `collectionId`, so this reads every page of the
 * collections list: a draft can be filed under any of them.
 */
export function useCollectionNames(
  collectionIds: readonly (string | null | undefined)[],
): ReadonlyMap<string, string> {
  const { data } = usePaginatedCollections({ fetchAll: true });
  const listed = data?.collections.results;

  return useMemo(() => {
    const wanted = new Set(collectionIds);
    return new Map(
      (listed ?? [])
        .filter((collection) => wanted.has(collection.id))
        .map((collection) => [collection.id, collection.title]),
    );
  }, [listed, collectionIds]);
}
